import script from "./EditMessagePage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMessagePage.vue?vue&type=script&setup=true&lang=js"

import "./EditMessagePage.vue?vue&type=style&index=0&id=eb0aced8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb0aced8"]])

export default __exports__